module.exports = __webpack_public_path__ + "static/media/Bubbly_ios_6_preview.f7e20065.jpg";